// ----------------------------------------------------------------------
// <copyright file="Izenda.Prediction.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var EventUtils = require('EventUtils');
  var connect = require('share/enhancers/Izenda.Connect');

  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var withState = require('recompose').withState;

  var PredictionConfigInput = require('./Izenda.PredictionConfigInput');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  const { curry } = require('lodash/fp');


  var action = compose(
    withState('show', 'setShow', true),
    withHandlers({
      onChange: curry(handleChangeConfig),
      toggleShow: curry(toggleShow)
    })
  );

  function handleChangeConfig(props, dataKey, value) {
    props.config.setValueByKey(dataKey, value);
  }

  function toggleShow(props, _) {
    props.setShow(!props.show);
  }

  var Prediction = function(props) {
    var config = props.config;
    var localization = props.localization;
    var show = props.show;
    const model = props.store.model;
    var collapseIcon = show ? 'icon-triangle-down' : 'icon-triangle-right';
    var titleIcon = show ? localization.getText('COMMON_LABEL_COLLAPSE') : localization.getText('COMMON_LABEL_EXPAND');
    return (
      <div>
        <div className="u-bgGray u_paddingAll">
          <a onClick={props.toggleShow}>
            <span title={titleIcon} className={collapseIcon} />
          </a>
          <span>{(model.dbConnectionShow) ? localization.getText('PREDICTION_SETTINGS_LABEL_TITLE'):localization.getText('NLQ_PREDICTION_SETTINGS_LABEL_TITLE')}</span>
        </div>
        {show && (
          <GridLayout className="u-bgWhite u_paddingAll">
            <PredictionConfigInput
             // title={localization.getText('PREDICTION_SETTINGS_LABEL_PREDICTION_SERVICE')}
            // value={config.displayName}
              dataKey="predictionServiceString"
              onChange={props.onChange}
              store={this.props.store}
              isRequired
              localization={this.props.localization}
              onclickdbconnection={this.props.onclickdbconnection}
              onclickmlserver={this.props.onclickmlserver}
              // placeholder="Enter Server Connection String"
            />
            {/* <PredictionConfigInput
              title={localization.getText('PREDICTION_SETTINGS_LABEL_PREDICTION_DB_CONNECTION_STRING')}
            //  value={config.emailFromAddress}
              dataKey="dbConnectionString"
              onChange={props.onChange}
              isRequired
              placeholder="Enter DB Connection String"
            /> */}
          </GridLayout>
        )}
      </div>
    );
  };

  module.exports = connect(action)(Prediction);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/MachineLearning/Izenda.Prediction.jsx